(function ($)
{
    /// <summary>
    /// Foxbright Vulpini ToolTip Widget.
    /// </summary>
    $.widget("ui.vptooltip",
    {
        options:
        {
            /// <summary>
            /// Returns the info for the tooltip in an array.  First entry is the title, second is the content.
            /// (This is a dummy function, the user should override this function with a custom function that
            ///  retrieves the data based on the id given)
            /// </summary>
            fetchContentElementCallback: function ( clickedObj )
            {
                //to be replaced with custom callback by the client.
            },

            bindHackCallback: function (jPopupDiv)
            {
            },

            // popup div.
            dialogClass: "vptooltip_dialog",

            // class to add to the anchor element.
            elementClass: "vptooltip_popper",

            popoverTimeout: 5000,

            // the time responsible for the delayed pop.
            timer: null,

            dialog: null,
        },

        _destroy: function ()
        {
            var self = this;
            var jElement = $(self.element);
            self._resetTimer();
            self._removePopup();
        },

        _init: function ()
        {
            var self = this;

        },

        _resetTimer: function ()
        {
            var self = this;
            if (self.options.timer)
            {
                clearTimeout(self.options.timer);
                self.options.timer = null;
            }
        },
        _create: function ()
        {
            var self = this;
            var jElement = $(this.element);

            jElement.addClass(self.options.elementClass);
            jElement.click(function (event)
            {
                event.preventDefault();
                self._buildPopup(this);
                return false;
            } )
            .keypress( function ( event )
            {
                var keycode = parseInt( event.keyCode ? event.keyCode : event.which );
                if ( keycode === 13 )
                {
                    event.preventDefault();
                    self._buildPopup( this );
                    return false;
                }
            } );

            $(document).click(function (event)
            {
                if (!$(event.target).closest("." + self.options.dialogClass).length)
                {
                    self._removePopup();
                }
            });

        },

        _removePopup: function ()
        {
            var dialog = this.options.dialog;
            this.options.dialog = null;
            if ( dialog !== undefined && dialog !== null )
            {
                this._resetTimer();
                $( dialog ).dialog( 'destroy' )
            }
        },

        /// <summary>
        /// Puts together the popup for to display, calls the user-defined getInfo function.
        /// </summary>
        _buildPopup: function (clickedObj)
        {
            var self = this;
            var jElement = $(self.element);
            var jClickedObj = $(clickedObj);

            self._removePopup();
            var contentElement = self.options.fetchContentElementCallback( clickedObj );
            var jContentElement = $( contentElement );
            jContentElement.dialog(
                {
                    open: function ()
                    {
                        FBUtilities.UpdateWidgetOverlayStyle(this);
                    },
                    modal: true,
                    title: '',
                    close: function ( event, ui )
                    {
                        jClickedObj.get( 0 ).focus();
                    },
                    position: {
                        my: "left+50 top+5",
                        at: "left top",
                        of: self.element
                    },
                    classes: 
                    {
                        "ui-dialog": `ui-corner-all ${self.options.dialogClass}`,
                        "ui-dialog-titlebar": "ui-corner-all"
                    }
                } );

            this.options.dialog = contentElement;

            self.options.bindHackCallback( jContentElement );

            if (self.options.popoverTimeout > 0)
            {
                self._resetTimer();
                $( jContentElement.dialog('widget')).mouseover(function ()
                {
                    self._resetTimer();
                });

                $( jContentElement.dialog( 'widget' ) ).mouseout( function ()
                {
                    self._resetTimer();
                    self.options.timer = setTimeout(function ()
                    {
                        self._removePopup();
                    }, self.options.popoverTimeout
                    );
                });
            }
        }
    });
})(jQuery);